import { useMemo } from "react";
import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

import PrintableSection from "pages/PrintableChecklist/components/PrintableSection";

import { IPackageCategory, IPackageSection } from "entities/Package/sdk";

export interface IPrintableCategory {
  category: IPackageCategory;
}

const PrintableCategory = ({ category }: IPrintableCategory) => {
  const areAllNA = useMemo(
    () =>
      _.every(
        _.map(category?.sections, (section) =>
          _.every(section?.fields, { n_a_status: true })
        )
      ),
    [category]
  );

  return (
    <Box id={category.category_id.toString()}>
      <Box
        sx={{
          padding: theme.spacing(0.5, 1),
          backgroundColor: colors.blue20,
          borderRadius: "4px",
          breakInside: "avoid",
        }}
      >
        <Stack spacing={1} direction="row" alignItems="center" minHeight="32px">
          <Text
            variant="text2"
            fontWeight="bold"
            color={areAllNA ? colors.gray60 : colors.black}
          >
            {category.name}
          </Text>
        </Stack>
      </Box>

      {_.uniqBy(category.sections, "section_id").map(
        (section: IPackageSection) => (
          <Stack
            sx={{
              paddingY: 1,
              paddingLeft: 2,
              borderRadius: "8px",
            }}
          >
            <PrintableSection key={section.section_id} section={section} />
          </Stack>
        )
      )}
    </Box>
  );
};

export default PrintableCategory;
